import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';

const Layout = () => {
  const { darkMode } = useContext(ThemeContext);
  const mainClassName = `${darkMode ? 'bg-dark text-light' : 'bg-light text-dark'}`;

  return (
    <>
      <Navbar />
      <main className={mainClassName}>
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default Layout;